import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import locales from "../locales";

const { defaultLanguage } = locales;
const languages = _.map(locales.languages, language => language.key);

const initialActions = {};

export default (mapStateToProps, actions = {}) => Component => {
  const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ ...initialActions, ...actions }, dispatch)
  });
  @connect(mapStateToProps, mapDispatchToProps)
  class WithRedux extends React.PureComponent {
    getLangData = (language, file) => {
      const langData = _.find(locales.languages, { key: language }).data[file];
      return langData;
    };
    getAnyLanguage = (content, file) => {
      let result = content;
      for (let index = 0; index < languages.length; index += 1) {
        const language = languages[index];
        const langData = this.getLangData(language, file);
        const contentLang = _.get(langData, content);
        if (contentLang) {
          result = contentLang;
          break;
        }
      }
      return result;
    };
    getDefaultLanguage = (content, file) => {
      const langData = this.getLangData(defaultLanguage, file);
      const contentLang = _.get(langData, content);
      if (!contentLang) return this.getAnyLanguage(content, file);
      return contentLang;
    };
    getDataFromObject = object => {
      const { currentActive } = this.props.language;
      let string = _.get(object, currentActive, _.get(object, defaultLanguage));
      if (!string) string = object[Object.keys(object)[0]];
      return string;
    };
    getDataFromString = (content, file) => {
      const { currentActive } = this.props.language;
      const langData = this.getLangData(currentActive, file);
      const contentLang = _.get(langData, content);
      if (!contentLang) return this.getDefaultLanguage(content, file);
      return contentLang;
    };
    getDataWithLanguage = (content, file = "default") => {
      if (_.isArray(content)) return content;
      let string = content;
      if (_.isObject(content)) {
        string = this.getDataFromObject(content);
      } else {
        string = this.getDataFromString(content, file);
      }
      if (string === true || _.isInteger(string)) {
      } else {
        if (_.isEmpty(string)) return null;
      }
      return string;
    };
    render() {
      return <Component {...this.props} t={this.getDataWithLanguage} />;
    }
  }
  return WithRedux;
};



// WEBPACK FOOTER //
// ./src/hoc/withRedux.js